export class RSAnimation
{
	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 * @param {?string} display
	 */
	static slideDown(element, duration = 350, callback = null, display = null)
	{
		element.style.removeProperty('display');

		let displayValue = window.getComputedStyle(element).display;
		if (displayValue === 'none') displayValue = (display != null) ? display : 'block';

		element.style.display = displayValue;

		let height = element.offsetHeight;

		element.style.overflow = 'hidden';
		element.style.height = 0;
		element.style.paddingTop = 0;
		element.style.paddingBottom = 0;
		element.style.marginTop = 0;
		element.style.marginBottom = 0;
		element.offsetHeight;
		element.style.boxSizing = 'border-box';

		element.style.transitionProperty = 'height, margin, padding';
		element.style.transitionDuration = duration + 'ms';
		element.style.height = height + 'px';

		element.style.removeProperty('padding-top');
		element.style.removeProperty('padding-bottom');
		element.style.removeProperty('margin-top');
		element.style.removeProperty('margin-bottom');

		window.setTimeout(() => {
			element.style.removeProperty('height');
			element.style.removeProperty('overflow');
			element.style.removeProperty('transition-duration');
			element.style.removeProperty('transition-property');

			if (callback != null) callback();
		}, duration);
	}


	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 */
	static slideUp(element, duration = 350, callback = null)
	{
		element.style.transitionProperty = 'height, margin, padding';
		element.style.transitionDuration = duration + 'ms';
		element.style.boxSizing = 'border-box';
		element.style.height = element.offsetHeight + 'px';
		element.offsetHeight;
		element.style.overflow = 'hidden';
		element.style.height = 0;
		element.style.paddingTop = 0;
		element.style.paddingBottom = 0;
		element.style.marginTop = 0;
		element.style.marginBottom = 0;

		window.setTimeout(() => {
			element.style.display = 'none';
			element.style.removeProperty('height');
			element.style.removeProperty('padding-top');
			element.style.removeProperty('padding-bottom');
			element.style.removeProperty('margin-top');
			element.style.removeProperty('margin-bottom');
			element.style.removeProperty('overflow');
			element.style.removeProperty('transition-duration');
			element.style.removeProperty('transition-property');

			if (callback != null) callback();
		}, duration);
	}


	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 * @param {?string} display
	 */
	static slideToggle(element, duration = 350, callback = null, display = null)
	{
		if (window.getComputedStyle(element).display === 'none')
		{
			RSAnimation.slideDown(element, duration, callback, display);
		}
		else
		{
			RSAnimation.slideUp(element, duration, callback);
		}
	}


	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 * @param {?string} display
	 */
	static fadeIn(element, duration = 350, callback = null, display = null)
	{
		element.style.removeProperty('display');

		let displayValue = window.getComputedStyle(element).display;
		if (displayValue === 'none') displayValue = (display != null) ? display : 'block';

		element.style.display = displayValue;
		element.style.opacity = '0';

		window.setTimeout(() => {
			element.style.transitionProperty = 'opacity';
			element.style.transitionDuration = duration + 'ms';
			element.style.opacity = '1';
		}, 10);

		window.setTimeout(() => {
			element.style.removeProperty('opacity');
			element.style.removeProperty('transition-duration');
			element.style.removeProperty('transition-property');

			if (callback != null) callback();
		}, (duration + 10));
	}


	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 */
	static fadeOut(element, duration = 350, callback = null)
	{
		element.style.transitionProperty = 'opacity';
		element.style.transitionDuration = duration + 'ms';
		element.style.opacity = '0';

		window.setTimeout(() => {
			element.style.display = 'none';
			element.style.removeProperty('transition-duration');
			element.style.removeProperty('transition-property');
			element.style.removeProperty('opacity');

			if (callback != null) callback();
		}, duration);
	}


	/**
	 * @param {HTMLElement} element
	 * @param {number} duration
	 * @param {?function} callback
	 * @param {?string} display
	 */
	static fadeToggle(element, duration = 350, callback = null, display = null)
	{
		if (window.getComputedStyle(element).display === 'none')
		{
			RSAnimation.fadeIn(element, duration, callback, display);
		}
		else
		{
			RSAnimation.fadeOut(element, duration, callback);
		}
	}


	/**
	 * @param {HTMLElement|Window} element - Example: document.documentElement
	 * @param {number} position
	 * @param {number} duration
	 */
	static scrollTo(element, position, duration = 350)
	{
		const elementIsWindow = (element === window);

		const easeInOutQuad = (t, b, c, d) => {
			t /= d/2;
			if (t < 1) return c/2*t*t + b;
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		};

		const start = !elementIsWindow ? element.scrollTop : element.scrollY;
		const change = (position - start);
		const startDate = new Date();

		if (duration > 0)
		{
			const animateScroll = () => {
				const currentDate = new Date();
				const currentTime = (currentDate - startDate);
				
				if (!elementIsWindow)
				{
					element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
					
					/*console.log({
						a: currentTime,
						b: start,
						c: change,
						d: parseInt(easeInOutQuad(currentTime, start, change, duration))
					});*/
				}
				else
				{
					element.scroll(0, parseInt(easeInOutQuad(currentTime, start, change, duration)));
					
					/*console.log({
						a: currentTime,
						b: start,
						c: change,
						d: parseInt(easeInOutQuad(currentTime, start, change, duration))
					});*/
				}
				
				if (currentTime < duration)
				{
					requestAnimationFrame(animateScroll);
				}
				else
				{
					if (!elementIsWindow)
					{
						element.scrollTop = position;
					}
					else
					{
						element.scroll(0, position);
					}
				}
			};
			
			animateScroll();
		}
		else
		{
			if (!elementIsWindow)
			{
				element.scrollTop = position;
			}
			else
			{
				element.scroll(0, position);
			}
		}
	}
}
